import * as Sentry from '@sentry/nextjs';
import { call, delay, SagaGenerator } from 'typed-redux-saga';

export function* callWithRetry<Args extends Array<unknown>, Fn extends (...args: Args) => Promise<any>>(
  fn: Fn,
  args: Args,
  maxAttempts: number,
  delayMs: number): SagaGenerator<Awaited<ReturnType<Fn>>> {
  let attempt = 0;

  while (true) {
    attempt += 1;

    try {
      return (yield* call(fn, ...args)) as Awaited<ReturnType<Fn>>;
    } catch (error) {
      Sentry.captureException(error);

      if (attempt >= maxAttempts) {
        throw error;
      }

      yield* delay(delayMs);
    }
  }
}
